module.exports = __webpack_public_path__ + "static/gebrauchstauglichkeitsakte-6dc9bc6d6bc8186d113caa2577404a10.png";